import { render, staticRenderFns } from "./form-ingrediente-ativo.vue?vue&type=template&id=6ac11144&"
import script from "./form-ingrediente-ativo.vue?vue&type=script&lang=js&"
export * from "./form-ingrediente-ativo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports